const getWindow = () => (typeof window !== 'undefined' ? window : undefined);

const hasWindow = typeof window !== 'undefined' && window;

const isUnsupported =
  hasWindow &&
  navigator !== undefined &&
  (/MSIE 9/i.test(navigator.userAgent) ||
    /MSIE 10/i.test(navigator.userAgent) ||
    /Trident/i.test(navigator.userAgent));

const isDebug = hasWindow && process.env.NODE_ENV === 'development';

const isWebglSupported = () => {
  try {
    const canvas = document.createElement('canvas');
    return (
      !!window.WebGLRenderingContext &&
      (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
    );
  } catch (_e) {
    return false;
  }
};

export { getWindow, hasWindow, isDebug, isUnsupported, isWebglSupported };
